import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .HistoryTable {
    .ReactDataTable__wrapper {
      .ReactDataTable {
        tr {
          grid-template-columns:
            50px /* avatar */
            minmax(120px, 1fr) /* fullName */
            minmax(120px, 1fr) /* performedBy */
            minmax(250px, 3fr) /* action */
            minmax(140px, 1fr); /* date */
        }

        .ReactDataTable__tbody-row {
          height: 75px;
        }

        .ReactDataTable__tbody-cell {
          display: flex;
          align-items: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &:nth-child(1) {
            justify-content: center;

            img {
              width: 35px;
              height: 35px;
              border-radius: 50%;
              object-fit: cover;
            }
          }

          &:nth-child(2),
          &:nth-child(3),
          &:nth-child(4),
          &:nth-child(5) {
            span {
              font-size: rem(13px);
            }
          }

          &:nth-child(2),
          &:nth-child(3) {
            span {
              font-weight: 500;
            }
          }
        }
      }
    }

    /* --- Responsive layout --- */
    .ResponsiveTable__thead {
      min-width: 320px !important;
      display: flex;

      span {
        text-align: center;
        padding: 5px 0;

        &:nth-child(1) {
          flex: 1; /* avatar */
        }

        &:nth-child(2) {
          flex: 3; /* fullName */
        }

        &:nth-child(3) {
          flex: 3; /* date */
        }
      }
    }

    .ResponsiveTable__row {
      .ResponsiveTable__row-item {
        display: flex;
        align-items: center;

        &:nth-child(1) {
          flex: 1;
          justify-content: center;

          img {
            width: 30px;
            height: 30px;
            border-radius: 50%;
          }
        }

        &:nth-child(2) {
          flex: 3;
          font-weight: 500;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        &:nth-child(3) {
          flex: 3;
          font-weight: 500;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .ResponsiveTable__details-item {
        padding-left: 15%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        .HistoryTable__action {
          white-space: wrap;
        }
      }
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .HistoryTable {
    }
  `;
};

export { staticStyles, getDynamicStyles };
